/* eslint-disable global-require */
let localConfig = {};
let oldLogoClubIds = [];
try {
    localConfig = require('./config-local.js').default;
} catch (e) {
    console.log('No local overrides');
}
try {
    oldLogoClubIds = require('./old-logo-club-ids.js').default;
} catch (e) {
    console.log('No old logo club ids');
}

const rootDomain = 'universaltennis.com';
const brandedDomain = 'UniversalTennis.com';
const twitterHandle = '@UniversalTennis';

const devFontUrl = 'https://cloud.typography.com/6323816/6761592/css/fonts.css'; // doesn't count against production page views
const localFontUrl = '/fonts/utr-fonts.css'; // for internal/offline use
const prodFontUrl = 'https://cloud.typography.com/6323816/6355392/css/fonts.css';

const links = {
    support: `https://support.${rootDomain}/support/tickets/new`,
    verifiedRules: '/verified',
    highSchoolVerifiedRules: `https://support.${rootDomain}/support/solutions/articles/9000165168-verified-high-school-scores`,
    wePayOrganizerFaq:
    `https://support.${rootDomain}/support/solutions/articles/9000157411-wepay-faq-for-event-organizers-`,
    eventOrganizerFaq: `https://support.${rootDomain}/support/solutions/articles/9000157361-frequently-asked-questions-about-utr-events-for-event-organizers-`,
    creatingDraws: `https://support.${rootDomain}/support/solutions/articles/9000158016-creating-draws`,
    howToMarketEvent: `https://support.${rootDomain}/support/solutions/articles/9000158018-how-do-i-market-my-utr-event-`,
    customizableFlyer: 'https://docs.google.com/presentation/d/1hC3U81zr_dp0vplLIfZ1NXcUK7cjvNTc-Mqs5ojMsCE/edit#slide=id.g46d7d30e9f_0_25',
    upgradeCollegeTypeform: 'https://universaltennis.typeform.com/to/DADAQ7',
    addScoreArticle: 'https://universaltennis.freshdesk.com/support/solutions/articles/9000170410-adding-scores',
    algorithmUnderstandingLink: `https://support.${rootDomain}/support/solutions/articles/9000151830-understanding-the-algorithm-complete-summary`,
    countsToUTR: `https://support.${rootDomain}/support/solutions/articles/9000138934-what-events-count-towards-my-utr-`,
    diffVerifiedUtr: `https://support.${rootDomain}/support/solutions/articles/9000154588-what-s-the-difference-between-utr-and-verified-utr-`,
    selfPostScoreRules: `https://support.${rootDomain}/support/solutions/articles/9000167002-post-a-score-self-posting`,
    findDemoPlayers: `https://support.${rootDomain}/support/solutions/articles/9000168924-demo-events`,
    hsRosterArticle: `https://support.${rootDomain}/support/solutions/articles/9000165080-managing-rosters`,
    appStoreUrl: 'https://apps.apple.com/us/app/universal-tennis/id1519232627',
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=com.ut.utr&utm_source=google-play&utm_campaign=web-footer-google-playstore-badge&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
};

const messaging = {
    pollingIntervalMin: 5000,
    pollingIntervalMax: 10000,
};

const messagingProd = {
    pollingIntervalMin: 10000,
    pollingIntervalMax: 30000,
};

const devAppInsightsKey = 'd2686756-dc48-49bd-9a46-7d6d37b5d349'; // Keep dev data out of App Insights
const prodAppInsightsKey = '78d2e9f4-06d6-47ec-87be-86a2bb9a146a';

const devRoxKey = '5eb1b5750f94f6d258634528';
const prodRoxKey = '5f4cf85aa8d0e73514557306';

const devStripeKey = 'pk_test_fJzi8lcnQbbKhlMJp9YVZ2tA00Wx6NIMm2';
const stripePublishableKey = process.env.STRIPE_PUBLISHABLE_KEY;

const prodSegmentKey = 'whKnzneZIJcBEMR0x98BGeVM31KywUGm';
const nonProdSegmentKey = 'xXYiDVo3i9VARfkxjcOdLy5q1oOJ0MQW';

const googleMapsApiKey = 'AIzaSyCapzh9VsfXAzC9fAaosZJulONx7H1BFaY';

const prodFacebookPixelId = '934768840401987';
const nonProdFacebookPixelId = '123456789123456';

const localDevSettings = {
    siteBaseUrl: process.env.siteBaseUrl || rootDomain,
    brandedUrl: process.env.brandedUrl || brandedDomain,
    twitterAccount: process.env.twitterAccount || twitterHandle,
    appHost: 'https://localhost:3443',
    appHostName: 'localhost',
    marketingAppHost: 'http://localhost:3001',
    apiHost: `https://ci-api.${rootDomain}`,
    userSiteHost: 'https://localhost:44300',
    teamTennisAppHost: 'https://localhost:3443',
    teamTennisAppHostName: 'localhost',
    userSiteHostName: 'localhost',
    fontUrl: localFontUrl,
    appInsightsKey: devAppInsightsKey,
    wePayHost: 'https://stage.wepay.com',
    wePayClientId: '91918',
    wePayEnvironment: 'stage',
    roxKey: devRoxKey,
    links,
    stripeKey: devStripeKey,
    messaging,
    alwaysUseProxy: true,
    oldLogoClubIds,
    isDev: true,
    googleMapsApiKey,
    pixelId: nonProdFacebookPixelId,
    ...localConfig,
};

const createTestSettings = (environmentName) => {
    return {
        siteBaseUrl: process.env.siteBaseUrl || rootDomain,
        brandedUrl: process.env.brandedUrl || brandedDomain,
        twitterAccount: process.env.twitterAccount || twitterHandle,
        appHost: process.env.APPHOST || `https://${environmentName}-app.${rootDomain}`,
        appHostName: process.env.APPHOSTNAME || `${environmentName}-app.${rootDomain}`,
        marketingAppHost: process.env.MARKETINGAPPHOST || `https://${environmentName}.${rootDomain}`,
        apiHost: process.env.APIHOST || `https://${environmentName}-api.${rootDomain}`,
        userSiteHost: process.env.USERSITEHOST || `https://${environmentName}-app.${rootDomain}`,
        userSiteHostName: process.env.USERSITEHOST || `${environmentName}-app.${rootDomain}`,
        teamTennisAppHost: process.env.LEAGUES_APP_HOST || `https://test1-leagues.${rootDomain}`,
        teamTennisAppHostName: process.env.LEAGUES_APP_HOST_NAME || `test1-leagues.${rootDomain}`,
        fontUrl: process.env.FONTURL || devFontUrl,
        appInsightsKey: process.env.APPINSIGHTS_INSTRUMENTATIONKEY || devAppInsightsKey,
        roxKey: devRoxKey,
        wePayHost: 'https://stage.wepay.com',
        wePayClientId: '91918',
        links,
        wePayEnvironment: 'stage',
        stripeKey: stripePublishableKey,
        messaging,
        cdnUrl: `https://${environmentName}-cdn.${rootDomain}`,
        staticCdnUrl: `https://${environmentName}-cdn-static.${rootDomain}`,
        segmentKey: nonProdSegmentKey,
        oldLogoClubIds,
        googleMapsApiKey,
        pixelId: nonProdFacebookPixelId,
    };
};

const qaServerSettings = createTestSettings('qa');
const ciServerSettings = createTestSettings('ci');
const testServerSettings = createTestSettings('test');
const test2ServerSettings = createTestSettings('test2');
const test3ServerSettings = createTestSettings('test3');
const test4ServerSettings = createTestSettings('test4');
const test5ServerSettings = createTestSettings('test5');
const test6ServerSettings = createTestSettings('test6');
const test7ServerSettings = createTestSettings('test7');
const test8ServerSettings = createTestSettings('test8');
const test9ServerSettings = createTestSettings('test9');
const test10ServerSettings = createTestSettings('test10');
const test11ServerSettings = createTestSettings('test11');
const rcServerSettings = createTestSettings('rc');

const prodServerSettings = {
    siteBaseUrl: process.env.siteBaseUrl || rootDomain,
    brandedUrl: process.env.brandedUrl || brandedDomain,
    twitterAccount: process.env.twitterAccount || twitterHandle,
    appHost: process.env.APPHOST || `https://app.${rootDomain}`,
    appHostName: process.env.APPHOSTNAME || `app.${rootDomain}`,
    marketingAppHost: process.env.MARKETINGAPPHOST || `https://${rootDomain}`,
    apiHost: process.env.APIHOST || `https://api.${rootDomain}`,
    userSiteHost: process.env.USERSITEHOST || `https://app.${rootDomain}`,
    userSiteHostName: process.env.USERSITEHOST || `app.${rootDomain}`,
    teamTennisAppHost: process.env.LEAGUES_APP_HOST || `https://leagues.${rootDomain}`,
    teamTennisAppHostName: process.env.LEAGUES_APP_HOST_NAME || `leagues.${rootDomain}`,
    fontUrl: process.env.FONTURL || prodFontUrl,
    appInsightsKey: process.env.APPINSIGHTS_INSTRUMENTATIONKEY || prodAppInsightsKey,
    wePayHost: process.env.WEPAY_HOST || 'https://www.wepay.com/',
    wePayClientId: process.env.WEPAY_CLIENT_ID || '154027',
    links,
    wePayEnvironment: process.env.WEPAY_ENV || 'production',
    stripeKey: stripePublishableKey,
    roxKey: process.env.ROX_KEY || prodRoxKey,
    messaging: process.env.MESSAGING || messagingProd,
    cdnUrl: process.env.CDN_URL || `https://prod-cdn.${rootDomain}`,
    staticCdnUrl: process.env.CDN_URL || `https://prod-cdn-static.${rootDomain}`,
    segmentKey: prodSegmentKey,
    redirectToWww: process.env.redirectToWww !== null ? process.env.redirectToWww === 'true' : true,
    oldLogoClubIds,
    googleMapsApiKey,
    pixelId: prodFacebookPixelId,
};

const stagingSettings = {
    siteBaseUrl: process.env.siteBaseUrl || rootDomain,
    brandedUrl: process.env.brandedUrl || brandedDomain,
    twitterAccount: process.env.twitterAccount || twitterHandle,
    appHost: process.env.APPHOST || `https://staging-app.${rootDomain}`,
    appHostName: process.env.APPHOSTNAME || `staging.${rootDomain}`,
    marketingAppHost: process.env.MARKETINGAPPHOST || `https://staging.${rootDomain}`,
    apiHost: process.env.APIHOST || 'https://staging-api.universaltennis.com',
    apiAuthToken: process.env.APIAUTHTOKEN || '2303cc78-0e7e-4b86-8ae6-74d05cd10cdf',
    userSiteHost: process.env.USERSITEHOST || `https://staging-app.${rootDomain}`,
    userSiteHostName: process.env.USERSITEHOST || `staging-app.${rootDomain}`,
    fontUrl: process.env.FONTURL || 'https://cloud.typography.com/6323816/6355392/css/fonts.css',
    appInsightsKey: process.env.APPINSIGHTS_INSTRUMENTATIONKEY || devAppInsightsKey,
    wePayHost: 'https://stage.wepay.com',
    wePayClientId: '91918',
    links,
    wePayEnvironment: 'stage',
    stripeKey: stripePublishableKey,
    messaging,
    cdnUrl: process.env.CDN_URL || `https://prod-cdn.${rootDomain}`,
    staticCdnUrl: process.env.CDN_URL || `https://prod-cdn-static.${rootDomain}`,
    segmentKey: nonProdSegmentKey,
    oldLogoClubIds,
    googleMapsApiKey,
    pixelId: nonProdFacebookPixelId,
};

// prod font: https://cloud.typography.com/6323816/6355392/css/fonts.css
// prod appInsights: 86f73473-038a-4975-8e7f-51ff990a2b98

// eslint-disable-next-line import/no-mutable-exports
let config = localDevSettings; // Default to local dev settings

const configSource = (process.env.CONFIG_SOURCE || process.env.NODE_ENV || 'development').toLowerCase();

console.log('config source:', configSource);

switch (configSource) {
    case 'production':
        config = prodServerSettings;
        break;
    case 'qa':
        config = qaServerSettings;
        break;
    case 'ci':
        config = ciServerSettings;
        break;
    case 'test':
        config = testServerSettings;
        break;
    case 'test2':
        config = test2ServerSettings;
        break;
    case 'test3':
        config = test3ServerSettings;
        break;
    case 'test4':
        config = test4ServerSettings;
        break;
    case 'test5':
        config = test5ServerSettings;
        break;
    case 'test6':
        config = test6ServerSettings;
        break;
    case 'test7':
        config = test7ServerSettings;
        break;
    case 'test8':
        config = test8ServerSettings;
        break;
    case 'test9':
        config = test9ServerSettings;
        break;
    case 'test10':
        config = test10ServerSettings;
        break;
    case 'test11':
        config = test11ServerSettings;
        break;
    case 'rc':
        config = rcServerSettings;
        break;
    case 'staging':
        config = stagingSettings;
        break;
    default:
        config = localDevSettings;
}

// Using this instead of ES6 syntax for compatibility with node
module.exports = config;
